








import { defineComponent } from '@nuxtjs/composition-api';
import SoleproError from '~/pages/solepro/Error.vue';

export default defineComponent({
  name: "ErrorLayout",
  props: {
    error: {
      type: Object,
      required: true,
    },
  },
  components:{
    SoleproError
  },
  setup(){
    
  }
});
